import React from 'react';

export function slugify(string, id = null) {
    const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
    const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnooooooooprrsssssttuuuuuuuuuwxyyzzz------'
    const p = new RegExp(a.split('').join('|'), 'g')

    var parsedString = id !== null ? string.toString().toLowerCase().substring(0,29) : string.toString().toLowerCase();

    parsedString = parsedString.toString().toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
        .replace(/&/g, '-and-') // Replace & with 'and'
        .replace(/[^\w\-]+/g, '') // Remove all non-word characters
        .replace(/\-\-+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, '') // Trim - from end of text

    // console.log('your-visit-id');
    // console.log(id);
    if(id !== null)
    {
        parsedString = parsedString + "-" + id
    }
    return parsedString
}

export function getVenueInfo(venueData) {
  return `${venueData.sqft} m² | ${venueData.people} people`;
}

export function rawContentToPlainText(blocks = []) {
  return blocks
    // loop through each block
    .map(block => {
      // if it's not a text block with children,
      // return nothing
      if (block._type !== 'block' || !block.children) {
        return ''
      }
      // loop through the children spans, and join the
      // text strings
      return block.children.map(child => child.text).join()
    })
    // join the parapgraphs leaving split by two linebreaks
    .join('\n\n')
}

export const decodeSanityAssetRef = ref => {
  const pattern = /^image-([a-f\d]+)-(\d+x\d+)-(\w+)$/
  const [, assetId, dimensions, format] = pattern.exec(ref)
  const [width, height] = dimensions.split("x").map(v => parseInt(v, 10))

  return {
    assetId,
    dimensions: { width, height },
    format,
  }
}
